<template>
  <div class="home">
    <app-header style="margin-bottom:3%;"></app-header>
    <app-rtap-header></app-rtap-header>
    <app-about-rtap></app-about-rtap>
    <app-footer></app-footer>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/general/Header.vue";
import RTapHeader from "@/components/general/RTapHeader.vue";
import AboutRtap from "@/components/rtap/AboutRtap.vue";
import Footer from "@/components/general/Footer.vue";

export default {
name: "home",
components: {
  'app-header': Header,
  'app-rtap-header': RTapHeader,
  'app-about-rtap': AboutRtap,
  'app-footer' : Footer,
  }
}   

</script>
